import { useEffect, useState } from 'react';
import { getCoachThread } from '@/services/mockData';

// Loads a coach thread for the given context slug. Async-shaped per AGENT_RULES
// Rule 3.1 — even though the mock resolves instantly, the loading/error pattern
// matches the real streaming endpoint that lands in BACKEND.md.

export function useCoachThread(contextSlug) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getCoachThread(contextSlug)
      .then((m) => { if (!cancelled) { setMessages(m); setLoading(false); } })
      .catch((e) => { if (!cancelled) { setError(e); setLoading(false); } });
    return () => { cancelled = true; };
  }, [contextSlug]);

  return { messages, loading, error };
}
